module.exports = __webpack_public_path__ + "img/Griffith.765dd99a.jpg";